import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="lesson-idiom"
export default class extends Controller {
  static targets = ['audio']

  connect() {
    console.log('Hey')
  }

  play(event) {
    this.audioTarget.play();
  }

  pause() {
    this.audioTarget.pause();
  }
}
